import React from "react"
import {FieldInlineEditableProps} from "../../../render/inline-editable";
import FieldDescriptionEditor_Component from "../components/editor";

export default function FieldDescriptionEditor_InlineEditable(props: FieldInlineEditableProps) {

    const value = props.model[props.field.fieldId]

    return <FieldDescriptionEditor_Component className = {props.className}
                          field     = {props.field}
                          value     = {value}
                          onChange  = {props.onChange}/>

}